// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__1-N9G","ldsRing":"Loader_ldsRing__FlgHJ"};